import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import RegisterPage from "@/pages/RegisterPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import RegistrantDetail from "@/pages/RegistrantDetail";
import ScannerPage from "@/pages/ScannerPage";
import AdminSettings from "@/pages/AdminSettings";
import AdminInventory from "@/pages/AdminInventory";
import AdminBroadcast from "@/pages/AdminBroadcast";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RegisterPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/registrant/:id" element={<RegistrantDetail />} />
          <Route path="/admin/scanner" element={<ScannerPage />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/inventory" element={<AdminInventory />} />
          <Route path="/admin/broadcast" element={<AdminBroadcast />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
